/* -----------------------------------------------------------------------------
 * Security Store Module (Security SM)
 *
 * @description Module for application Security logic
 * -----------------------------------------------------------------------------
 */

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  namespaced: true, // Use module namespace feature
  state,
  getters,
  mutations,
  actions
}
